// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6524":"ac84c115","6775":"512d131b"}[chunkId] + ".chunk.css";
};